import authQueries from "../../queries/authQueries";
import React, { useState, useEffect, useRef } from 'react';
import { message, message as messages, Popconfirm } from "antd";
import { red } from "@mui/material/colors";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { formatTimestamp, formatCustomDate, calculateDaysTillToday } from '../../helpers/dateFormatter';
import '../../assets/css/file-upload.css';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
  Select,
  SelectItem
} from "@nextui-org/react";
import DateTimePicker from '../common/datepicker.tsx';
import { userStore } from '../../store/userStore';
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../Constants/RouteConstant.js";

// Validation schema for the contact informant form
const validationSchemaForm1 = yup.object({
  sendresponse: yup
    .string("⚠ Enter Message Body")
    .required("⚠ Message Body is required"),
});

// Validation schema for the schedule form
const validationSchemaForm2 = yup.object({
  datetime: yup
    .string("⚠ Select Date Time")
    .required("⚠ Date Time is required"),
});

export default function Action({ 
  compliant , 
  companyID, 
  users, 
  handleAssign, 
  edit, setEdit, 
  btnLoader, setBtnLoader, 
  mailcontent, isLoading, 
  sendcontactinformantmail, 
  setIsLoading,
  setAdditionalMsg, 
  onSubmitForm1,
  setSchedule,
  isOpenstate,
  setIsOpenstate,
  setscheduleContent,
  isScheduleLoading,
  onSubmitForm2,
  setDatetime,
  datetime,
  sendCancellationMail,
  refreshComplaintData, // Add this prop to refresh complaint data
  setCompliant // Add this prop to update complaint state directly
}) {

  const navigate = useNavigate()
  const [errName, setErrName] = useState("");
  const [err, setErr] = useState("please enter the message body");
  const [response, setResponse] = useState([]);

  const [sendresponse, setsendresponse] = useState("");

const isActive = true; // Always show Contact Informant tab
const className = `tab-pane ${isActive ? 'active' : ''}`;
const classNameSec = `tab-pane ${isActive ? '' : 'active'}`;
const displayVal = `block`; // Always display the tab

  const [issueClosed, setIssueClosed] = useState('NO');
  const [lessonLearned, setLessonlearned] = useState('');
  const [isLessonLoading, setisLessonLoading] = useState(false);
  const [issueclosedErr, setissueclosedErr] = useState(false);
  const [howissueclosed, setHowissueclosed] = useState("");
  const [assignee, setAssignee] = useState({id: null, name: ''})
  const [newAssignee, setNewAssignee] = useState(null)
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [showProgress, setShowProgress] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const schemaData = userStore();
  const [isDeleting, setIsDeleting] = useState(false);
  const [deletingFileId, setDeletingFileId] = useState(null);
  
  useEffect(()=> {
 
    if(compliant?.complaint_assigns?.length > 0){
      const user = compliant?.complaint_assigns?.find(item=> (item.status === "ACTIVE" && item?.app_user?.user_role?.roleid === 4))
      if(user){
        setAssignee({id: user?.assignee, name: `${user?.app_user?.fname} ${user?.app_user?.lname}`})
      }
    }

  },[compliant?.complaint_assigns])



  const handleFileClick = () => {
    fileInputRef.current.click()
  }

  const handleUploadClick = () => {
    if (!selectedFile) return;
    
    const fileName = selectedFile.name.length > 12 ? `${selectedFile.name.substring(0, 13)}... .${selectedFile.name.split('.')[1]}` : selectedFile.name;

    setFiles((prevState) => [...prevState, { name: fileName, loading: 0 }]);
    setShowProgress(true);

    handleFileUpload(selectedFile, setFiles, setUploadedFiles, setShowProgress);
    
    // Clear selected file after starting upload
    setSelectedFile(null);
  }

  const handleCancelSelection = () => {
    setSelectedFile(null);
  }

  const handleFileUpload = async (file, setFiles, setUploadedFiles, setShowProgress) => {
    const fileName = file.name;
    const fileSize = file.size < 1024 ? `${file.size} B` : file.size < 1024 * 1024 ? `${(file.size / 1024).toFixed(2)} KB` : `${(file.size / (1024 * 1024)).toFixed(2)} MB`;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('complaint_id',compliant?.id)

    try {
      setIsUploading(true);
      const xhr = new XMLHttpRequest();

      xhr.open('POST', `${process.env.REACT_APP_BASE_URL}/api/employerupload/upload`, true);

      xhr.setRequestHeader('schema', schemaData?.companyData?.company);
      
      // Add authorization header
      const token = schemaData?.user?.jwttoken;
      if (token) {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      }

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const loaded = event.loaded;
          const total = event.total;
          const progress = Math.floor((loaded / total) * 100);

          setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            if (newFiles.length > 0) {
              newFiles[newFiles.length - 1].loading = progress;
            }
            return newFiles;
          });
        }
      };

      xhr.onload = () => {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            console.log('Server response:', response);
            console.log('File object:', file);
            console.log('setCompliant function available:', !!setCompliant);
            
            // Add to uploaded files with server response data
            setUploadedFiles((prevUploadedFiles) => {
              const newFiles = [...prevUploadedFiles, { 
                name: fileName, 
                size: fileSize, 
                file,
                uploadedData: response // Store server response
              }];
              console.log('Files after upload:', newFiles.length);
              return newFiles;
            });
            
            // Immediately add the uploaded file to complaint attachments for instant display
            if (setCompliant && response && response.files && response.files.length > 0) {
              const fileData = response.files[0]; // Get the first file from the response
              console.log('Adding file to complaint attachments. File data:', fileData);
              console.log('Current complaint before update:', compliant);
              
              setCompliant(prevCompliant => {
                console.log('Previous complaint state:', prevCompliant);
                
                const newAttachment = {
                  id: fileData.attachment_id || Date.now(),
                  file_name: fileData.fileName || fileData.url || fileName,
                  file_type: fileData.mimeType || file.type,
                  uploaded_by: 'EMPLOYER',
                  created_at: new Date().toISOString(),
                  file_size: fileData.size || file.size
                };
                
                console.log('New attachment object:', newAttachment);
                
                const updatedComplaint = {
                  ...prevCompliant,
                  complaint_attachments: [
                    ...(prevCompliant.complaint_attachments || []),
                    newAttachment
                  ]
                };
                
                console.log('Updated complaint with new attachment:', updatedComplaint);
                console.log('Total attachments after update:', updatedComplaint.complaint_attachments?.length);
                return updatedComplaint;
              });
            } else {
              console.log('setCompliant not available or response/files empty');
            }
            
            // Clear loading state
            setFiles([]);
            setShowProgress(false);
            setIsUploading(false);
            
            // Clear uploaded files since they're now in complaint_attachments
            setUploadedFiles([]);
            
            // Optional: Also refresh complaint data from server
            if (refreshComplaintData) {
              setTimeout(() => refreshComplaintData(), 1000); // Delay to ensure server has processed
            }
          } catch (error) {
            console.error('Error parsing upload response:', error);
            alert('Upload completed but response parsing failed');
            setFiles([]);
            setShowProgress(false);
            setIsUploading(false);
          }
        } else {
          console.error('Upload failed with status:', xhr.status);
          alert('Upload failed. Please try again.');
          setFiles([]);
          setShowProgress(false);
          setIsUploading(false);
        }
      };

      xhr.onerror = () => {
        console.error('Upload error occurred');
        alert('Upload error occurred. Please try again.');
        setFiles([]);
        setShowProgress(false);
        setIsUploading(false);
      };

      xhr.send(formData);
    } catch (error) {
      console.error('Error during file upload:', error);
      alert('Error during file upload. Please try again.');
      setFiles([]);
      setShowProgress(false);
      setIsUploading(false);
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    // Count existing employer files from complaint data
    const existingEmployerFiles = compliant?.complaint_attachments?.filter(
      attachment => attachment.uploaded_by === 'EMPLOYER'
    ) || [];
    
    // Check if already at maximum files (only count existing files since uploadedFiles are already in complaint_attachments)
    if (existingEmployerFiles.length >= 3) {
      alert("Maximum 3 files allowed. Please remove a file before adding a new one.");
      e.target.value = ''; // Clear the input
      return;
    }
    
    console.log(file)
    
     // Validate file type
     const allowedTypes = [
      "image",
      "audio",
      "video",
      "application/pdf",
      "application/vnd.ms-excel",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    
    const fileType = file.type.split("/")[0]; // Get the main type (image, audio, video, application)
    
    const fileExtension = file.name.split(".").pop().toLowerCase(); // Get the file extension

    console.log("File Type:", fileType);
    console.log("File Extension:", fileExtension);

    if (!allowedTypes.find((type) => type === fileType || type === file.type)) {
      alert("Invalid file type. Please upload only images, audio, video files, and documents.");
      e.target.value = ''; // Clear the input
      return false;
    }

    const fileSize = 10 * 1024 * 1024

    if(file.size > fileSize) {
      alert("Maximum size exceeded")
      e.target.value = ''; // Clear the input
      return false
    }

    // Just set the selected file, don't upload immediately
    setSelectedFile(file);
    
    // Clear the input so the same file can be selected again if needed
    e.target.value = '';
  };

  const removeUploadedFile = (index) => {
    setUploadedFiles((prevUploadedFiles) => {
      const fileToRemove = prevUploadedFiles[index];
      
      // Also remove from complaint attachments if setCompliant is available
      if (setCompliant && fileToRemove?.uploadedData) {
        setCompliant(prevCompliant => ({
          ...prevCompliant,
          complaint_attachments: (prevCompliant.complaint_attachments || []).filter(
            attachment => {
              // Match by filename or ID from server response
              const serverFileName = fileToRemove.uploadedData.fileName || fileToRemove.uploadedData.filename;
              return attachment.file_name !== serverFileName && 
                     attachment.id !== fileToRemove.uploadedData.id;
            }
          )
        }));
      }
      
      // Create a copy of the array without the file at the specified index
      const updatedFiles = [...prevUploadedFiles];
      updatedFiles.splice(index, 1);
      console.log('Files after removal:', updatedFiles.length);
      return updatedFiles;
    });
  };

  const handleDateChange = (value, dateString) => {
  };

  const options = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
	  }

  const handleOk = (value) => {
    setDatetime(value);
    setValue("datetime", value);
  };

  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    control: controlForm1,
    formState: { errors: errorsForm1 },
  } = useForm({
    resolver: yupResolver(validationSchemaForm1),
  });

  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    control: controlForm2,
    setValue,
    formState: { errors: errorsForm2 },
  } = useForm({
    resolver: yupResolver(validationSchemaForm2),
  });


  const Lesson = authQueries.useLessonMutation((response) => {
    if (response?.message === "Success") {
      messages.success("Submitted Successfully");
      navigate(RouteConstants.DASHBOARD)
    } else if (response?.error[0]?.name) {
      setErrName("⚠ " + response?.error[0]?.name);
    }
  });

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      setIssueClosed('YES');
      setissueclosedErr(true);
    } else {
      setIssueClosed('NO');
      setissueclosedErr(false);
    }
    console.log("setIssueClosed", event.target.checked);
  };

  const lessonSubmit = () => {
    if(issueClosed==='YES' && howissueclosed===''){
      setissueclosedErr(true);
      return
    }else{
      setissueclosedErr(false);
    }
    setisLessonLoading(true);
    
    // Format uploaded files for API - extract the server response data
    const formattedFiles = uploadedFiles.map(file => ({
      fileName: file.uploadedData?.fileName || file.name,
      originalName: file.name,
      size: file.size,
      ...file.uploadedData // Include any additional data from server response
    }));
    
    const datavalues = {
      complaintId: compliant.id,
      lesson_learned: lessonLearned,
      is_issue_closed: issueClosed,
      howissueclosed: howissueclosed,
      uploaded_files: formattedFiles,
      schema: schemaData?.companyData?.company
    };
    
    console.log('Submitting lesson with files:', formattedFiles);
    
    Lesson.mutateAsync(datavalues).then(() => {
      setisLessonLoading(false);
    }).catch((error) => {
      console.error('Error submitting lesson:', error);
      setisLessonLoading(false);
    });
  };




  const handleSelectUser =(e)=> {
    setNewAssignee(e?.target?.value)
  }
  
  const handleSubmit =async()=> {
    setBtnLoader(true)
    if(newAssignee === null){
      return message.error("Please select one user")
    }
    await handleAssign({assignee: newAssignee, complaint_id: compliant?.id, old_assignee: assignee?.id, complaint: compliant})
    setNewAssignee(null)
  }

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // const isActive = compliant?.is_contact_informant === 1;
  // const className = `tab-pane ${isActive ? 'active' : ''}`;
  // const classNameSec = `tab-pane ${isActive ? '' : 'active'}`;
  // const displayVal = `${isActive ? 'block' : 'none'}`;


  const isDisabled = compliant?.complaint_assigns?.find(item => 
    (item?.app_user?.user_role?.roleid === 4 && 
     item?.status === "ACTIVE" && 
     item?.assignee === schemaData?.user?.id && 
     item?.isaccept === "NO")
  ) || isLessonLoading;


  const handleDeleteFile = async (fileItem) => {
		try {
			setIsDeleting(true);
			setDeletingFileId(fileItem.id);

			// Call the delete API with attachment_ids array
			await deleteEmployerFile.mutateAsync({
				attachment_ids: [fileItem.id],
				schema: companyID?.companyData?.company
			});

			// Remove the file from the local state after successful deletion
			if (setCompliant) {
				setCompliant(prevCompliant => ({
					...prevCompliant,
					complaint_attachments: (prevCompliant.complaint_attachments || []).filter(
						attachment => attachment.id !== fileItem.id
					)
				}));
			}

		} catch (error) {
			console.error('Error deleting file:', error);
			message.error("Failed to delete file");
			setIsDeleting(false);
			setDeletingFileId(null);
		}
	};

  const deleteEmployerFile = authQueries.useEmployerFileDelete(
		(response) => {
			if (response?.message === "File deletion process completed" || response?.summary?.database_updated > 0) {
				message.success("File deleted successfully");
			} else {
				message.error("Failed to delete file");
			}
			setIsDeleting(false);
			setDeletingFileId(null);
		}
	);



	const handleDownload = (item) => {
		window.open(item)
	}


  return (
    <>
      <div className="col-md-6">
        <h5>Action & Response</h5>

        <div className="card">
          <div className="card-body">

            <div className="issue-response-form">
              <label>Account User Assigned</label>
              <div>
              {
                !edit ?
                <div className="input-group mb-3">
                    <input type="text" className="form-control" placeholder="User Assigned" value={assignee?.name} />
                  {(companyID?.user?.role=== 'SUPERUSER' && users.length>1) &&
                    <div className="input-group-append">
                      <button title="Click here if you want to change Account user" className="btn btn-edit text-white" type="submit" onClick={()=> {setEdit(true)}}><i className="icon-pencil3"></i></button>
                    </div>
                  }
                </div>:
                <div className="flex items-center gap-4 mb-3 mt-2">
                  {users?.length > 0 && 
                  <Select
                      labelPlacement="outside"
                      placeholder="Account User Assigned"
                      onChange={(e) => handleSelectUser(e)}
                  >
                      {users?.map((option) => (
                        (option?.id !== assignee?.id) &&
                        <SelectItem key={option.id} value={option.id}>
                          {option.name}
                        </SelectItem>
                      ))}
                  </Select>
                  }
                  <div className="input-group-append">
                      <button disabled={btnLoader} className="btn btn-edit text-white" type="submit" onClick={handleSubmit}><i className="icon-tick"></i></button>
                  </div>
                </div>
              }
              </div>
            </div>

            {/* <h6 className="blue-label">Does {capitalizeFirstLetter(companyID?.company?.company?.short_name.toLowerCase())}  want SHIPCONREP to</h6> */}
            <ul className="nav nav-tabs">
              <li className="nav-item"  style={{ display: displayVal }} >
                <a className="nav-link active" data-bs-toggle="tab" href="#contactinformant"><span>&nbsp;</span><br />Message to SHIPCONREP</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-bs-toggle="tab" href="#sendresponse"><span>&nbsp;</span><br />Send a Response to the Reporter</a>
              </li>
            </ul>

            <div className="tab-content">
              {/* <div   className={className} id="contactinformant">
                <div className="col-md-12 sendresponse-form">
                  <textarea disabled className="form-control" value={mailcontent} placeholder="Enter the message">
                  </textarea>
                  <div className="additional-message-cntnr mt-3">
                    {compliant?.shipconrep_contact_informant==='YES'?
                    <p >The Above confirmation Mail sent to Shipconrep on { formatCustomDate(compliant?.shipconrep_contact_informant_at, options)} </p>:null}
                    {compliant?.callback === 'YES' && compliant?.shipconrep_contact_informant==='NO' ?
                      <div className="custom-check-wrpr">
                        <div className="custom-control custom-checkbox text-end">
                        
                          <input type="checkbox" className="custom-control-input" id="additionalmsg" name="additionalmsg" />
                         
                          <textarea onChange={(e)=>{setAdditionalMsg(e.target.value)}} className="form-control d-none" placeholder="Enter the message"></textarea>
                          <label className="custom-control-label" htmlFor="additionalmsg">Tick here to add additional message to SHIPCONREP</label>
                        </div>
                      </div> : null
                    }
                  </div> */}
                  <div className={className} id="contactinformant">
                    <div className="col-md-12 sendresponse-form">
                      {
                        compliant?.callback === 'YES' ? (
                          <>
                            <textarea disabled className="form-control" value={mailcontent} placeholder="Enter the message"></textarea>
                            <div className="additional-message-cntnr mt-3">
                              {compliant?.shipconrep_contact_informant==='YES' ? (
                                <p>The Above confirmation Mail sent to Shipconrep on {formatCustomDate(compliant?.shipconrep_contact_informant_at, options)}</p>
                              ) : null}
                              {compliant?.shipconrep_contact_informant==='NO' && (
                                <div className="custom-check-wrpr">
                                  <div className="custom-control custom-checkbox text-end">
                                    <input type="checkbox" className="custom-control-input" id="additionalmsg" name="additionalmsg" />
                                    <textarea onChange={(e) => { setAdditionalMsg(e.target.value) }} className="form-control d-none" placeholder="Enter the message"></textarea>
                                    <label className="custom-control-label" htmlFor="additionalmsg">Tick here to add additional message to SHIPCONREP</label>
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <textarea className="form-control" onChange={(e) => setAdditionalMsg(e.target.value)} placeholder="Type your message to SHIPCONREP here"></textarea>
                          </>
                        )
                      }
                                    <div className="text-end mt-3">
                                    {!(compliant?.callback === 'YES' && compliant?.shipconrep_contact_informant === 'YES') && (
                    <Popconfirm
                      placement="left"
                      title="Are you sure?"
                      onConfirm={(event) => sendcontactinformantmail(event)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        disabled={compliant?.complaint_assigns?.find(item => (
                          item?.app_user?.user_role?.roleid === 4 &&
                          item?.status === "ACTIVE" &&
                          item?.assignee === schemaData?.user?.id &&
                          item?.isaccept === "NO"
                        ))}
                        className={
                          compliant?.complaint_assigns?.find(item => (
                            item?.app_user?.user_role?.roleid === 4 &&
                            item?.status === "ACTIVE" &&
                            item?.assignee === schemaData?.user?.id &&
                            item?.isaccept === "NO"
                          )) ? "bg-primary-200 cursor-not-allowed" : "bg-primary"
                        }
                        color="primary"
                        size="sm"
                        radius="full"
                      >
                      {isLoading ? <Spinner className="testspinner" color="default" size="md" /> : null}
                  {compliant?.callback === 'YES' ? 'Send Confirmation' : 'Send Message'}

                      </Button>
                    </Popconfirm>
                  )}


                        
                      </div>
                    </div>
                  </div>
              <div className={classNameSec} id="sendresponse">
                <form onSubmit={handleSubmitForm1(onSubmitForm1)}>
                  <div className="col-md-12 sendresponse-form">
                    <textarea name="sendresponse" maxLength={5000} {...registerForm1("sendresponse")} onChange={(e) => setscheduleContent(e.target.value)} className="form-control" placeholder="Enter below to send response to the Repoter" ></textarea>
                    <div className="mt-2">
                    {compliant?.email_schedule?.mail_schedule_time && (
                      <>The above response scheduled to send to the Reporter on {formatCustomDate(compliant.email_schedule.mail_schedule_time, options)}</>
                    )}
                  </div>

                    <div className="error-msg">
                      {errorsForm1.sendresponse?.message} {errName}
                    </div>
                    <div className="text-end">
                      <Button 
                        type="submit" 
                        onPress={() => { setSchedule(false) }} 
                        disabled={compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? true: false}
                        className={compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? "bg-primary-200 cursor-not-allowed": "bg-primary"}
                        color="primary" size="sm" radius="full" 
                      >
                        {isLoading ? <Spinner className="testspinner" color="default" size="md" /> : null}
                        Send
                      </Button>
                      <Button 
                        type="submit" 
                        onPress={() => { setSchedule(true) }} 
                        disabled={compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? true: false}
                        className={compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? "bg-primary-200 cursor-not-allowed": "bg-primary"}
                        color="primary" 
                        size="sm" radius="full"
                       >
                        {isScheduleLoading ? <Spinner className="testspinner" color="default" size="md" /> : null}
                        Schedule later
                      </Button>
                    </div>
                  </div>
                </form>
                <div className="col-md-12  hidden-content" style={{display:"none"}}>
                  <h5 className="blue-label">Previous Messages</h5>
                  <div className="prev-messages">
                    <h6>Jul 28, 2021, 11:26 am - Mohit Dua</h6>
                    <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.</p>
                    <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form.</p>
                    <p>In publishing and graphic design, Lorem ipsum is a form of a document or a typeface without relying on meaningful content.</p>
                  </div>
                  <div className="prev-messages">
                    <h6>Jul 28, 2021, 11:26 am - Mohit Dua</h6>
                    <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="issue-response-form issue-insight">
              <div className="row">
                <div className="col-md-12">
                  <h5>Issue Insight</h5>
                </div>
                <div className="col-md-12">
                  <label>Lessons learned by {capitalizeFirstLetter(companyID?.company?.company?.short_name)}</label>
                  <textarea maxLength={5000} onChange={(e) => { setLessonlearned(e.target.value) }} className="form-control" placeholder="Lessons learned..." ></textarea>
                </div>
              </div>
            </div>

            <div className="issue-response-form">
                <div className="row">
                  <div className="additional-message-cntnr mt-3">
                    <div className="custom-check-wrpr">
                      <div className="custom-control custom-checkbox text-end">
                        <input onChange={(e)=>{handleCheckboxChange(e)}} type="checkbox" className="custom-control-input" id="closemsg" name="closemsg" />
                        <textarea maxLength={5000} onChange={(e) => { setHowissueclosed(e.target.value) }} className="form-control d-none" placeholder="Provide details on how the issue was closed"></textarea>
                        <label className="custom-control-label" htmlFor="closemsg">Was the issue closed by the {companyID?.company?.company?.short_name}</label>
                      </div>
                    </div> 
                  </div>
                  <div className="error-msg">
                         {issueclosedErr?"⚠ This field is required before this issue can be closed":''} 
                  </div>
            </div>
            </div>

            <div className="issue-response-form">
              <div className="row">
                <div className="col-md-8">
                  <label>&nbsp;</label>
                </div>
                <div className="col-md-4 text-end">
                    {/* <Popconfirm
                      placement="left"
                      title={"Are you sure you want to " + (issueClosed==='YES'? "close this issue?" : "Submit?")}
                      onConfirm={(event) => lessonSubmit(event)}
                      okText="Yes"
                      cancelText="No"
                    > */}
                    
                      <Button 
                      {...(isDisabled ? {} : { onPress: (e) => lessonSubmit(e) })} 
                      disabled={compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? true: false}
                      className={compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? "bg-primary-200 cursor-not-allowed": "bg-primary"}
                      color="primary" 
                      size="sm" 
                      radius="full" >
                      {isLessonLoading ? <Spinner className="testspinner" color="default" size="md" /> : null}
                      Submit
                      </Button>
                    {/* </Popconfirm> */}
                </div>
              </div>
            </div>

            {/* General File Upload Section */}
            <div className="issue-response-form">
              <div className="row">
                <div className="col-md-12">
                  <label className="haveInfo">Upload supporting documents - </label>
                  <small><strong style={{color: 'red'}}> 10 MB</strong> maximum for each file allowed and maximum 3 files can be uploaded eg. pictures video, audio or document.</small>
                  
                  <div className='upload-box'>
                    You can Upload Maximum 3 files
                    {(() => {
                      const existingEmployerFiles = compliant?.complaint_attachments?.filter(
                        attachment => attachment.uploaded_by === 'EMPLOYER'
                      ) || [];
                      // Count only existing files from complaint data, not local uploadedFiles
                      // since uploadedFiles are already included in complaint_attachments after upload
                      const totalFiles = existingEmployerFiles.length;
                      const isMaxReached = totalFiles >= 3;
                      const remainingSlots = 3 - totalFiles;
                      const disabledAccntUser=compliant?.complaint_assigns?.find(item => (item?.app_user?.user_role?.roleid === 4 && item?.status === "ACTIVE" && item?.assignee === schemaData?.user?.id && item?.isaccept === "NO")) ? true: false
                      const isDisabled = isMaxReached || isUploading || disabledAccntUser; 
                      
                      return (
                        <div>
                          <div className='layout' style={{height: isMaxReached ? 50 : 170, cursor: isDisabled ? 'not-allowed' : 'pointer'}} onClick={!isDisabled && !selectedFile ? handleFileClick : undefined}>

                            <input 
                              type="file"
                              className="file-input"
                              name='file'
                              hidden
                              disabled={isDisabled}
                              onChange={handleFileChange} 
                              ref={fileInputRef}
                            />

                            {isUploading ? (
                              <div className='iconn'>
                                <div className="spinner-border text-primary" role="status" style={{width: '48px', height: '48px'}}>
                                  <span className="sr-only">Uploading...</span>
                                </div>
                              </div>
                            ) : !isMaxReached && !selectedFile && (
                              <div className='iconn'>
                                <i className='icon-file_upload' style={{fontSize: '48px', color: '#007bff'}}></i>
                              </div>
                            )}

                            {isUploading ? (
                              <p>Uploading file...</p>
                            ) : selectedFile ? (
                              <div style={{textAlign: 'center', padding: '20px'}}>
                                <div className='iconn'>
                                  <i className='icon-file' style={{fontSize: '48px', color: '#28a745'}}></i>
                                </div>
                                <p style={{margin: '10px 0', fontWeight: 'bold'}}>{selectedFile.name}</p>
                                <p style={{margin: '5px 0', fontSize: '12px', color: '#666'}}>
                                  Size: {selectedFile.size < 1024 ? `${selectedFile.size} B` : 
                                         selectedFile.size < 1024 * 1024 ? `${(selectedFile.size / 1024).toFixed(2)} KB` : 
                                         `${(selectedFile.size / (1024 * 1024)).toFixed(2)} MB`}
                                </p>
                              </div>
                            ) : (
                              <>
                                {remainingSlots === 3 && <p>3 More Files to upload</p>}
                                {remainingSlots === 2 && <p>2 More Files to upload</p>}
                                {remainingSlots === 1 && <p>1 More File to upload</p>}
                                {remainingSlots <= 0 && <p>Maximum files Uploaded</p>}
                              </>
                            )}

                          </div>
                          
                          {/* Upload and Cancel buttons for selected file */}
                          {selectedFile && !isUploading && (
                            <div style={{marginTop: '15px', textAlign: 'center', display: 'flex', gap: '10px', justifyContent: 'center'}}>
                              <Button 
                                color="primary" 
                                size="sm" 
                                radius="full"
                                onPress={handleUploadClick}
                                disabled={isDisabled}
                                className={isDisabled ? "bg-primary-200 cursor-not-allowed" : "bg-primary"}
                              >
                                <i className='icon-upload' style={{marginRight: '5px'}}></i>
                                Upload File
                              </Button>
                              <Button 
                                color="danger" 
                                variant="flat"
                                size="sm" 
                                radius="full"
                                onPress={handleCancelSelection}
                              >
                                <i className='icon-cross' style={{marginRight: '5px'}}></i>
                                Cancel
                              </Button>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                    
                    {showProgress && (
                      <section className='loading-area'>
                        {files.map((file, index) => (
                          <li className='roww' key={index}>
                            <i className='icon-file'></i>
                            <div className='content'>
                              <div className='details'>
                                <div className='name'>
                                  {`${file.name} uploading`}
                                </div>
                                <div className='percent'>
                                  {`${file.loading}%`}
                                </div>
                                <div className='loading-bar'>
                                  <div className='loading' style={{width: `${file.loading}%`}}>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </section>
                    )}
                    
                    <section className='uploaded-area'>
                      {uploadedFiles.map((file, index) => (
                        <li className='roww' key={index}>
                          <div className='content-upload'>
                            <i className='icon-file'></i>
                            <div className='details'>
                              <span className='name'>{file.name}</span>
                              <span className='size'>{file.size}</span>
                            </div>
                          </div>
                          <div className='file-actions'>
                            <i className='icon-check' style={{color: '#198754', marginRight: '10px'}}></i>
                            
                          </div>
                        </li>
                      ))} 
                    </section>

                  </div>
                </div>
              </div>
            </div>

            <div class="detail-group">
							<label>Employer Attachment</label>
							<div class="attachment-links" style={{
								marginTop: '10px',
								display: 'flex',
								flexDirection: 'column',
								width: '100%'
							}}>
								{(() => {
									console.log('IssueView - All complaint attachments:', compliant?.complaint_attachments);
									const employerFiles = compliant?.complaint_attachments?.filter(item => item?.uploaded_by === 'EMPLOYER') || [];
									console.log('IssueView - Employer files:', employerFiles);
									return employerFiles;
								})().map((item, index) => {
									let fileName = item?.file_name || 'Unknown file';
									let fileExtension = '';
									
									// Extract filename from URL if it's a full URL
									if (item?.file_name?.includes("/")) {
										console.log("item?.file_name", item?.file_name)
										try {
											const urlObject = new URL(item?.file_name);
											const pathname = urlObject.pathname;
											fileName = pathname.split('/').pop();
										} catch (error) {
											// If URL parsing fails, try to extract filename from path
											fileName = item?.file_name.split('/').pop();
										}
									}
									
									// Extract file extension
									if (fileName && fileName.includes('.')) {
										const parts = fileName.split('.');
										fileExtension = parts.pop().toUpperCase();
										fileName = parts.join('.');
									}

									// Combine filename and extension for display
									const displayName = fileName + (fileExtension ? '.' + fileExtension : '');

									return (
										<div
											key={index}
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
												padding: '8px 12px',
												marginBottom: '8px',
												border: '1px solid #e0e0e0',
												borderRadius: '4px',
												backgroundColor: '#f9f9f9'
											}}
										>
											{/* File name and extension */}
											<div style={{
												display: 'flex',
												alignItems: 'center',
												flex: 1
											}}>
												<i className="icon-file" style={{
													marginRight: '8px',
													color: '#007bff',
													fontSize: '16px'
												}}></i>
												<span
													style={{
														fontSize: '14px',
														color: '#333',
														cursor: 'pointer',
														textDecoration: 'underline'
													}}
													onClick={() => { handleDownload(item?.file_name) }}
													title="Click to download"
												>
													{displayName}
												</span>
											</div>

											{/* Delete button */}
											<button
												className='btn btn-sm btn-danger'
												onClick={() => handleDeleteFile(item)}
												disabled={isDeleting && deletingFileId === item.id}
												style={{
													padding: '4px 8px',
													fontSize: '12px',
													borderRadius: '4px',
													opacity: (isDeleting && deletingFileId === item.id) ? 0.7 : 1,
													marginLeft: '10px'
												}}
												title={isDeleting && deletingFileId === item.id ? "Deleting..." : "Delete file"}
											>
												{isDeleting && deletingFileId === item.id ? (
													<div className="spinner-border spinner-border-sm" role="status" style={{ width: '12px', height: '12px' }}>
														<span className="sr-only">Loading...</span>
													</div>
												) : (
													<i className='icon-delete'></i>
												)}
											</button>
										</div>
									)
								})}

								{/* No attachment message */}
								{(!compliant?.complaint_attachments || compliant?.complaint_attachments?.filter(item => item?.uploaded_by === 'EMPLOYER').length === 0) && (
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										width: '100%',
										padding: '20px',
										color: '#999',
										fontSize: '14px',
										fontStyle: 'italic',
										border: '1px solid #e0e0e0',
										borderRadius: '4px',
										backgroundColor: '#f9f9f9'
									}}>
										<p>No Attachment</p>
									</div>
								)}
							</div>
						</div>


            

          </div>
        </div>
      </div>

      <Modal
        isOpen={isOpenstate}
        onOk={() => (false)}
        onCancel={() => setIsOpenstate(false)}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <form onSubmit={handleSubmitForm2(onSubmitForm2)} >
                <ModalHeader className="flex flex-col gap-1">Select Date And Time</ModalHeader>
                <ModalBody>
                  <DateTimePicker register={registerForm2} showTime onChange={handleDateChange} onOk={handleOk} value={datetime} format="YYYY-MM-DD HH:mm" />
                  <div className="error-msg">
                    {errorsForm2.datetime?.message} {errName}
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="danger" variant="flat" onClick={() => setIsOpenstate(false)}>
                    Close
                  </Button>
                  <Button color="primary" type="submit">
                    Submit
                  </Button>
                </ModalFooter>
              </form>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
